import styles from "../../styles/expenses.create.statement.modal.module.css";
import {Statistic, Tag} from "antd";
import React from "react";


// Компонент заголовка с итогами
export const TotalsHeader = ({selectedStaff, totals}) => (
    <div className={styles.totalsHeader}>
        <div>
            <span>Добавленные сотрудники: </span>
            <Tag color="blue">{selectedStaff.length} чел.</Tag>
        </div>
        <div className={styles.totalsStats}>
            <Statistic
                title="Наличные"
                value={totals.totalCash}
                precision={2}
                suffix="€"
                valueStyle={{fontSize: '16px'}}
            />
            <Statistic
                title="Безнал (без НДС)"
                value={totals.totalNonCashWithoutVAT}
                precision={2}
                suffix="€"
                valueStyle={{fontSize: '16px'}}
            />
            <Statistic
                title="Безнал (с НДС 13%)"
                value={totals.totalNonCashWithVAT}
                precision={2}
                suffix="€"
                valueStyle={{fontSize: '16px'}}
            />
        </div>
    </div>
);